import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import { useApi } from "../../../../../hooks/useApi";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import CalendarModal from "../../../../Modal/CalendarModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import LineBtn from "../../../../Button/LineBtn";
import { Input } from "../../../../Input/Input";
import { encryptPW } from "../../../../../Api/ApiCommon";

interface SecretModeSetModalProps {
  cancelEvent: () => void;
  secretOffEvent: () => void;
  partyId: string;
  isSecret: string;
  shareid: string;
  idtype: string;
  password: string;
  adltPw: string;
  owner: string;
  updateEvent: () => Promise<void>;
}

export default function ChangePartyAccinfoSetModal({
  cancelEvent,
  secretOffEvent,
  isSecret,
  partyId,
  shareid,
  password,
  idtype,
  adltPw,
  owner,
  updateEvent,
}: SecretModeSetModalProps) {
  const [ChangeBtnClick, setChangeBtnClick] = useState(false);

  const [endDate, setEndDate] = useState("선택");

  const [hourDropdownValue, setHourDropdownValue] = useState<OptionType>({
    value: "",
    label: "시",
  });
  const [minuteDropdownValue, setMinuteDropdownValue] = useState<OptionType>({
    value: "",
    label: "분",
  });

  const [AccInfos, setAccInfos] = useState({
    idtype: idtype,
    shareid: shareid,
    password: password,
  });

  const { response } = useApi({
    method: "post",
    url: ChangeBtnClick ? `party/${partyId}/shareid/party` : undefined,
    data: {
      idtype: AccInfos.idtype,
      shareid: AccInfos.shareid,
      password: encryptPW(
        {
          pw: AccInfos.password!,
          adltPw: adltPw!,
        },
        Number(owner)
      ),
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      cancelEvent();
      updateEvent();
      toast.success("파티 계정정보가 변경되었습니다.", {});
    }
  }, [response]);

  // 시간 선택 옵션
  const hourOptionList = [];
  const hourList = Array.from({ length: 24 }, (_, i) => i);

  for (let i = 0; i < hourList.length; i++) {
    const e = hourList[i];
    hourOptionList.push({
      value: e < 10 ? `0${e}` : `${e}`,
      label: e < 10 ? `0${e}` : `${e}`,
    });
  }

  // 분 선택 옵션
  const minuteOptionList = [];
  const minuteList = Array.from({ length: 6 }, (_, i) => i);

  for (let i = 0; i < minuteList.length; i++) {
    const e = minuteList[i];
    minuteOptionList.push({ value: `${e}0`, label: `${e}0` });
  }

  return (
    <DefaultModalLayout
      modalTitle="파티 계정 설정"
      isSmallModal={true}
      closeEvent={() => cancelEvent()}
      confirmEvent={() => setChangeBtnClick(true)}
      type="input"
      // confirmDisabled={
      //   endDate === "선택" ||
      //   hourDropdownValue?.value === "" ||
      //   minuteDropdownValue?.value === ""
      // }
    >
      {/* 종료일 */}
      <Row>
        <ModalLabel>로그인 수단</ModalLabel>

        <ValueContainer>
          <LineBoxContainer>
            <Input
              value={AccInfos.idtype}
              onChange={(e) =>
                setAccInfos({
                  ...AccInfos,
                  idtype: e.target.value,
                })
              }
              type="text"
              placeholder="직접 입력"
              // maxLength={10}
              disabled={true}
            />
          </LineBoxContainer>
        </ValueContainer>
      </Row>

      {/* 종료 시간 */}
      <Row>
        <ModalLabel>공유 ID</ModalLabel>

        <ValueContainer>
          <Input
            value={AccInfos.shareid}
            onChange={(e) =>
              setAccInfos({
                ...AccInfos,
                shareid: e.target.value,
              })
            }
            type="text"
            placeholder="직접 입력"
            // maxLength={10}
            disabled={false}
          />
        </ValueContainer>
      </Row>

      <Row>
        <ModalLabel>공유 비밀번호</ModalLabel>

        <ValueContainer>
          <Input
            value={AccInfos.password}
            onChange={(e) =>
              setAccInfos({
                ...AccInfos,
                password: e.target.value,
              })
            }
            type="text"
            placeholder="직접 입력"
            // maxLength={10}
            disabled={false}
          />
        </ValueContainer>
      </Row>
    </DefaultModalLayout>
  );
}

const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

const ValueContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const LineBoxContainer = styled.div`
  position: relative;
`;
